<main class="account-page">
  <section class="account-card account-card--wide">
    <p class="eyebrow">Password Recovery</p>
    <h1>Reset your password</h1>
    <p class="lede">
      Request a reset passcode, then use it here with your new password.
    </p>

    <div class="recovery-grid">
      <form [formGroup]="requestForm" (ngSubmit)="requestReset()" class="account-form">
        <h2>1. Request code</h2>
        <label>
          <span>Email</span>
          <input
            type="email"
            formControlName="email"
            autocomplete="email"
            placeholder="you@example.com"
          />
          @if (requestForm.controls.email.invalid &&
          requestForm.controls.email.touched) {
          <small>Please enter a valid email.</small>
          }
        </label>

        <button type="submit" class="primary-action" [disabled]="isRequesting">
          {{ isRequesting ? 'Sending...' : 'Send Reset Code' }}
        </button>
      </form>

      <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" class="account-form">
        <h2>2. Set password</h2>
        <label>
          <span>Email</span>
          <input
            type="email"
            formControlName="email"
            autocomplete="email"
            placeholder="you@example.com"
          />
        </label>

        <label>
          <span>Passcode</span>
          <input
            type="text"
            formControlName="passcode"
            inputmode="numeric"
            autocomplete="one-time-code"
            maxlength="6"
            placeholder="000000"
          />
          @if (resetForm.controls.passcode.invalid &&
          resetForm.controls.passcode.touched) {
          <small>Enter the six-digit passcode.</small>
          }
        </label>

        <label>
          <span>New password</span>
          <input
            type="password"
            formControlName="password"
            autocomplete="new-password"
            placeholder="At least 8 characters"
          />
          @if (resetForm.controls.password.invalid &&
          resetForm.controls.password.touched) {
          <small>Password must be at least 8 characters.</small>
          }
        </label>

        <label>
          <span>Re-enter new password</span>
          <input
            type="password"
            formControlName="confirmPassword"
            autocomplete="new-password"
            placeholder="Re-enter new password"
          />
          @if (resetForm.controls.confirmPassword.hasError('mismatch')) {
          <small>Passwords do not match.</small>
          } @else if (resetForm.controls.confirmPassword.invalid &&
          resetForm.controls.confirmPassword.touched) {
          <small>Please re-enter the new password.</small>
          }
        </label>

        <button type="submit" class="primary-action" [disabled]="isResetting">
          {{ isResetting ? 'Resetting...' : 'Reset Password' }}
        </button>
      </form>
    </div>

    @if (infoMessage) {
    <div class="form-alert form-alert--success">{{ infoMessage }}</div>
    }
    @if (errorMessage) {
    <div class="form-alert form-alert--error">{{ errorMessage }}</div>
    }

    <div class="account-links">
      <a routerLink="/login">Back to login</a>
    </div>
  </section>
</main>
